export const EXTRA_FIELD_ENTITY_TYPES = [
  { value: "User", label: "User" },
  { value: "Client", label: "Client" },
  { value: "Order", label: "Order" },
];

export const EXTRA_FIELD_PLACEMENT_OPTIONS = [
  { value: "OTHER_TAB", label: "Others" },
  { value: "OVERVIEW_TAB", label: "Overview" },
];

export const EXTRA_FIELD_COLUMN_OPTIONS = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
];

export const DEFAULT_EXTRA_FIELD_DISPLAY = {
  placement: "OTHER_TAB",
  columns: 1,
};

export const normalizeExtraFieldDisplay = (doc) => {
  const source = doc && typeof doc === "object" ? doc : {};
  return {
    placement:
      source.placement === "OVERVIEW_TAB" ? "OVERVIEW_TAB" : "OTHER_TAB",
    columns: source.columns === 2 ? 2 : 1,
  };
};

export const EXTRA_FIELD_TYPES = [
  { value: "TEXT", label: "Text" },
  { value: "TEXTAREA", label: "Text Area" },
  { value: "INTEGER", label: "Number (Integer)" },
  { value: "DECIMAL_2", label: "Number (2 decimal)" },
  { value: "DECIMAL_4", label: "Number (4 decimal)" },
  { value: "DATE", label: "Date" },
  { value: "DATETIME", label: "Date Time" },
  { value: "SELECT", label: "Select List" },
  { value: "BOOLEAN", label: "Boolean (Y/N)" },
  { value: "FILE", label: "Single File" },
  { value: "FILES", label: "Files" },
  { value: "REF_USER", label: "User List" },
  { value: "REF_CLIENT", label: "Client List" },
  { value: "REF_PROVIDER", label: "Insurer / Provider List" },
  { value: "REF_PRODUCT", label: "Product List" },
  { value: "REF_PRODUCT_CATEGORY", label: "Product Category" },
  { value: "REF_PRODUCT_TYPE", label: "Product Type / Class" },
];

export const REF_EXTRA_FIELD_TYPES = new Set([
  "REF_USER",
  "REF_CLIENT",
  "REF_PROVIDER",
  "REF_PRODUCT",
  "REF_PRODUCT_CATEGORY",
  "REF_PRODUCT_TYPE",
]);

export const isRefExtraFieldType = (fieldType) =>
  REF_EXTRA_FIELD_TYPES.has(fieldType);

export const isNumberExtraFieldType = (fieldType) =>
  ["INTEGER", "DECIMAL_2", "DECIMAL_4"].includes(fieldType);

export const isFileExtraFieldType = (fieldType) =>
  fieldType === "FILE" || fieldType === "FILES";

export const isMultiFileExtraFieldType = (fieldType) => fieldType === "FILES";

export const getExtraFieldNumberPrecision = (fieldType) => {
  if (fieldType === "INTEGER") return 0;
  if (fieldType === "DECIMAL_2") return 2;
  if (fieldType === "DECIMAL_4") return 4;
  return undefined;
};

export const REF_ENTITY_CONFIG = {
  REF_USER: {
    apiEntity: "user",
    searchFields: ["staffId", "name", "cname", "aliasName", "email"],
    labelRender: (data) =>
      `${data.name || ""}${data.aliasName ? `, ${data.aliasName}` : ""} (${
        data.staffId ?? "--"
      })`,
    pageSize: 20,
  },
  REF_CLIENT: {
    apiEntity: "client",
    searchFields: ["code", "name", "cname", "id"],
    labelRender: (data) =>
      `[ ${data.code ?? data.id ?? "--"} ] ${data.name || ""}${
        data.cname ? ` (${data.cname})` : ""
      }`,
    pageSize: 20,
  },
  REF_PROVIDER: {
    apiEntity: "provider",
    searchFields: ["code", "insurerCode", "name", "shortName"],
    labelRender: (data) =>
      `[${data.code || data.insurerCode || ""}] ${data.name || ""}`,
    pageSize: 20,
  },
  REF_PRODUCT: {
    apiEntity: "product",
    searchFields: ["code", "name", "cname", "planCode"],
    labelRender: (data) => `[${data.code ?? ""}] ${data.name ?? ""}`,
    pageSize: 20,
  },
  REF_PRODUCT_CATEGORY: {
    apiEntity: "productCategory",
    searchFields: ["code", "name", "cname"],
    labelRender: (data) => `[${data.code ?? ""}] ${data.name ?? ""}`,
    pageSize: 50,
  },
  REF_PRODUCT_TYPE: {
    apiEntity: "productType",
    searchFields: ["code", "name", "cname", "groupCode"],
    labelRender: (data) => `[${data.code ?? ""}] ${data.name ?? ""}`,
    pageSize: 300,
  },
};

export const REF_IMPORT_HINTS = {
  REF_USER: "Import: Staff ID",
  REF_CLIENT: "Import: Client Code",
  REF_PROVIDER: "Import: Provider Code",
  REF_PRODUCT: "Import: Product Code",
  REF_PRODUCT_CATEGORY: "Import: Category Code",
  REF_PRODUCT_TYPE: "Import: Product Type Code",
};
